import { useSearch } from "@tanstack/react-router";
import { useGetIncomingPostbackQuery } from "api/TenantSlug/IncomingPostback/hooks.ts";
import { ModifyPostbackIncomingForm } from "components/Forms/ModifyPostbackIncomingForm/ModifyPostbackIncomingForm";
import { Drawer } from "components/UI/Drawer";
import { useDrawer } from "hooks/useDrawer";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

import { DrawerTitle } from "../../UI/DrawerTitle/DrawerTitle.tsx";

interface SearchParams {
    [`modifyIncomingPostback-id`]: string;
}

export const ModifyPostbackIncomingDrawer: FC = () => {
    const { t } = usePaldockTranslation("drawers.modify-postback-incoming");
    const drawerId = DrawerId.ModifyIncomingPostback;
    const drawerUtils = useDrawer();

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const incomingPostbackId = searchParams[`${drawerId}-id`];
    const getIncomingPostbackQuery = useGetIncomingPostbackQuery(incomingPostbackId, {
        filter: { fields: { incoming_postbacks: "name" } },
    });

    if (
        getIncomingPostbackQuery.isLoading ||
        getIncomingPostbackQuery.isFetching ||
        !getIncomingPostbackQuery.data?.incomingPostback
    ) {
        return <></>;
    }
    const incomingPostback = getIncomingPostbackQuery.data.incomingPostback;

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title")} subTitles={[incomingPostback.name]} />}
            searchParamsToClean={[`${drawerId}-id`]}
        >
            <ModifyPostbackIncomingForm
                onClose={() => drawerUtils.hide(drawerId)}
                incomingPostback={incomingPostback}
            />
        </Drawer>
    );
};
